import {CenterProps} from "../../../../features/map/types";
import {Country, LATAM_COUNTRY_NAMES,} from "../../../../features/countries/types";
import {regionEnv} from "../../../../config";
import {ZOOM_MAP} from "./types";

const calculateZoomAndCenter = (
  isXlScreen: boolean,
  isOverThen1450Resolution: boolean,
  isOverThen1700Resolution: boolean,
  containerWidth: number,
  containerHeight: number,
  zoom: number,
  selectedCountry: Country
) => {
  let zoomFactor = 1;
  if (isXlScreen) zoomFactor = 0.8;
  if (isOverThen1450Resolution) zoomFactor = 0.95;
  if (isOverThen1700Resolution) zoomFactor = 1;

  const {country_name, country_width, country_height, centro_id} =
    selectedCountry;

  const newZoomForLATAMCountries =
    country_name.toUpperCase() !== LATAM_COUNTRY_NAMES.LATAM
      ? Math.min(
        containerWidth / (Number(country_width) * zoomFactor),
        containerHeight / (Number(country_height) * zoomFactor)
      )
      : zoom;

  const up = Number(country_height) * 0.01 || 0;
  const newCenter: CenterProps = [centro_id[0], centro_id[1] - up];

  const manualZooms = {
    [`${LATAM_COUNTRY_NAMES.PERU}`]: 6,
    [`${LATAM_COUNTRY_NAMES.ECUADOR}`]: 17,
    [`${LATAM_COUNTRY_NAMES.PARAGUAY}`]: 12,
    [`${LATAM_COUNTRY_NAMES.BOLIVIA}`]: 8,
  };

  const manualAppliedZoom = manualZooms[country_name] || null;

  const newZoom =
    country_name.toUpperCase() === regionEnv
      ? ZOOM_MAP
      : newZoomForLATAMCountries;

  return {center: newCenter, zoom: manualAppliedZoom || newZoom};
};

export default calculateZoomAndCenter;
